import { memo, useCallback, useRef, useState } from "react";
import { useAppDispatch, useAppSelector } from "stores";
import { Toolbar, Button, CardActions, Typography, Paper } from "@mui/material";
import { useTranslation } from "react-i18next";
import Spacer from "components/Spacer";
import { Delete, DriveFileMoveOutlined } from "@mui/icons-material";
import { getAppState } from "stores/modules/app.state/selectors";
import { deleteUserSelectedMedia } from "stores/modules/entities.user.media/operations";
import { appStateMutate } from "stores/modules/app.state/operations";
import MediumListSelectingMediaMoveMenu from "./MediumListSelectingMediaMoveMenu";
import styled from "styled-components";

const MediumListSelectingMediaFooter = () => {
  const d = useAppDispatch();
  const [t] = useTranslation();
  const selectedMediaIds = useAppSelector((state) => {
    return getAppState(state, "selectedMediaIds");
  });
  const anchorEl = useRef(null);
  const [open, setOpen] = useState(false);
  const onToggle = useCallback(() => {
    setOpen((open) => !open);
  }, [setOpen]);
  const onClose = useCallback(() => {
    setOpen(false);
  }, [setOpen]);

  const deleteSelectedMedia = useCallback(() => {
    if (
      selectedMediaIds.length === 0 ||
      !window.confirm(
        t("{{length}}件のデータを削除します。本当によろしいですか？", {
          length: selectedMediaIds.length,
        })
      )
    ) {
      return;
    }
    d(deleteUserSelectedMedia(selectedMediaIds));
    d(
      appStateMutate((state) => {
        state.selectingMedia = false;
        state.selectedMediaIds = [];
      })
    );
  }, [d, selectedMediaIds, t]);

  return (
    <FloatBar square>
      <FooterToolbar>
        <Typography variant="body2">
          {t("{{length}} 件を選択中", {
            length: selectedMediaIds.length,
          })}
        </Typography>
        <Spacer />
        <CardActions>
          <Button
            onClick={onToggle}
            ref={anchorEl}
            disabled={selectedMediaIds.length === 0}
            startIcon={<DriveFileMoveOutlined />}
          >
            {t("移動")}
          </Button>
          <Button
            onClick={deleteSelectedMedia}
            disabled={selectedMediaIds.length === 0}
            startIcon={<Delete />}
          >
            {t("削除")}
          </Button>
        </CardActions>
        <MediumListSelectingMediaMoveMenu
          open={open}
          onClose={onClose}
          anchorEl={anchorEl.current}
        />
      </FooterToolbar>
    </FloatBar>
  );
};

const FloatBar = styled(Paper)`
  background: #222;
`;

const FooterToolbar = styled(Toolbar)`
  padding: 0 16px;
`;

export default memo(MediumListSelectingMediaFooter);
